<!-- <div class="pb-8 mb-8 border-b border-black">
     <div class="pb-4 text-xl font-bold">Record Sharing</div>
     <div class="basicForm__checkboxOption">
     <input type="checkbox" id="enablePublicNotes" @change="updateEnablePublicNotes()" v-model="isSharingEnabled" />
     <label for="enablePublicNotes" class="basicForm__checkboxLabel">Enable Public Notes <a href="https://www.tatatap.com/public-notes" target="_blank" class="info-link">?</a></label>
     </div>
     <div class="pt-4">
     <t-label class="pb-2">Choose a name</t-label>
     <t-text lvl="2" kind="DANGER" v-if="error[0] === 'handleError'">{{error[1]}}</t-text>
     <form @submit.prevent="updateHandle">
     <div class="flex items-center">
     <span class="font-mono text-base py-2 pl-4 pr-1 bg-white rounded-l">@</span>

     <input
     class="appearance-none mr-4 rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
     v-model="handle"
     placeholder="Choose a name" />

     <t-button>Save</t-button>

     </div>
     </form>
     <t-label class="pt-2 text-grey-darker">This name is used to create the URL for your public note pages.</t-label>
     </div>
     </div> -->

<template>
  <div>
    <shell>
      <div class="container m-auto px-4 lg:px-0">
        <div class="w-full md:w-1/2 pb-6 m-auto px-2">
          <div class="text-3xl font-bold pb-12">Build</div>

          

          
          <div class="pb-8 mb-8 border-b border-black">
            <div class="pb-4 text-xl font-bold flex items-baseline">
              <span>Imports</span>
              <router-link to="/imports" class="ml-4 text-base font-normal">My Imports</router-link>
            </div>
            <p class="mb-4 leading-normal">To import records from other services use one of the below importers.</p>

            <p class="mb-4 leading-normal">If we don't have what you need, get in touch! We can probably import your records anyway. hello@tatatap.com</p>

            <div class="pb-4">
              <router-link to="/import-keep">Google Keep</router-link>
            </div>
            <div class="pb-4">
              <router-link to="/import-pinboard">Pinboard</router-link>
            </div>
            <div class="pb-4">
              <router-link to="/import-csv">CSV</router-link>
            </div>

            
          </div>
          <div class="pb-8 mb-8 border-b border-black">
            <div class="pb-4 text-xl font-bold flex items-baseline">
              <span>Records To-Go</span>
              <router-link to="/exports" class="ml-4 text-base font-normal">My Exports</router-link>
            </div>
            <p class="mb-4">Create a website or raw data export of your records.</p>

          </div>

          <div class="pb-8 mb-8 border-b border-black">

            <div class="pb-4 text-xl font-bold flex items-baseline">
              <span>Spells</span>
              <router-link to="/spells" class="ml-4 text-base font-normal">My Spells</router-link>
            </div>
            <spell-bar  />
          </div>



          <div class="pb-8 mb-8 border-b border-black">
            <div class="flex justify-between align-center">
              <div>
                <div class="pb-2 text-xl font-bold">Connections</div>
                <p class="mb-6 text-xs">Connect your messaging accounts here.</p>
              </div>
            </div>

            <div class="pb-6" v-if="connections.length">
              <div v-for="c in connections" class="pb-6">
                <div v-if="c.type === 'SIGNAL'">
                  <div class="flex justify-between">
                    <div class="pb-4">
                      <div class="pb-2 font-bold">Signal Messenger</div>
                      <div class="text-red underline" @click="deleteConnection(c)">Delete</div>
                    </div>
                    <div class="ml-4">
                      <div v-if="c.is_verified" class="rounded-full bg-green pt-2 px-4 pb-1 text-white">Verified</div>
                      <div v-else-if="c.is_failed" class="rounded-full bg-red pt-2 px-4 pb-1 text-white">Failed to connect</div>
                      <div v-else class="text-full-blue underline cursor-pointer"
                        @click="resendConnectionVerification(c)">Resend verification code</div>
                    </div>
                  </div>
                  <div class="pb-4">
                    <label class="text-xs pb-2 block">Your Number</label>
                    <div>{{formatIntlNumber(c.target)}}</div>
                  </div>
                  <div class="pb-4">
                    <label class="text-xs pb-2 block">Tap Number</label>
                    <div>{{formatIntlNumber(c.origin)}}</div>
                  </div>
                </div>

                <div v-if="c.type === 'TELEGRAM'">
                  <div class="flex justify-between">
                    <div class="pb-4">
                      <div class="pb-2 font-bold">Telegram Messenger</div>
                      <div class="text-red underline" @click="deleteConnection(c)">Delete</div>
                    </div>
                    <div class="ml-4">
                      <div v-if="c.is_verified" class="rounded-full bg-green pt-2 px-4 pb-1 text-white">Verified</div>
                      <div v-else-if="c.is_failed" class="rounded-full bg-red pt-2 px-4 pb-1 text-white">Failed to connect</div>
                    </div>
                  </div>
                  <div class="pb-4">
                    <label class="text-xs pb-2 block">Your Account</label>
                    <div>{{c.target_info.first_name}} {{c.target_info.last_name}} <a v-if="c.target_info.username" :href="`https://t.me/${c.target_info.username}`">@{{c.target_info.username}}</a></div>
                  </div>
                  <div class="pb-4">
                    <label class="text-xs pb-2 block">Tap Account</label>
                    <div>Tap Bot <a :href="`https://t.me/${c.origin}`">@{{c.origin}}</a></div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <t-button @click="isAddConnectionModalVisible = true">Add Connection</t-button>
              <add-connection-modal :isModalVisible="isAddConnectionModalVisible"
                @close="isAddConnectionModalVisible = false"
                @complete="getConnections" />
            </div>
          </div>

          <div class="pb-8 mb-8 border-b border-black">

            <div class="pb-4 text-xl font-bold">Reaction Groups</div>
            <div class="basicForm__checkboxOption">
              <input type="checkbox" id="showReactionGroups" @change="updateReactionGroupPref()" v-model="reactionGroupPref" />
              <label for="showReactionGroups" class="basicForm__checkboxLabel">Show reaction groups on main page <a href="https://www.tatatap.com/reaction-groups" target="_blank" class="info-link">?</a></label>
            </div>
          </div>




          <div class="pb-8 mb-8 border-b border-black">
            <div class="pb-4 text-xl font-bold">Bookmarklets</div>
            <p class="mb-4 leading-normal">To quickly save a webpage along with a record use the <a class="text-full-blue" :href="jsURL">Tap capture website</a>. The bookmarklet will launch a simple popup window containing a form to add a record. The form is prefilled with the current webpage and fields to find a folder and tags.</p>

            <p class="mb-4 leading-normal">To capture a record <strong>without</strong> a webpage, use the standard bookmarklet <a class="text-full-blue" :href="jsURLNoUrl">Tap capture record</a>.</p>
            <p class="mb-4 leading-normal">Drag one of the above &ldquo;Tap capture&rdquo; links above to your bookmarks toolbar to save it.</p>
          </div>

          

          


          <div class="pb-8 mb-8 border-b border-black">
            <div class="pb-4 text-xl font-bold">How-to</div>
            <p class="mb-4 leading-normal">For the complete Tap How-to guide see <a href="https://www.tatatap.com/how-to" class="text-full-blue" target="_blank">here.</a> This guide walks you through the different types of records and how to create them. It also explains how to enhance your record collecting abilities using <strong>Spells</strong>.</p>
          </div>

          <div class="pb-8 mb-8 border-b border-black">
            <div class="pb-4 text-xl font-bold">Support</div>
            <p class="mb-4 leading-normal"><a class="text-full-blue" href="mailto:hello@tatatap.com">hello@tatatap.com</a></p>
          </div>
          
        </div>
      </div>
      <connection-verification-modal
        v-if="verificationConnection"
        :connection="verificationConnection"
        @close="closeConnectionVerificationModal"
        @complete="closeConnectionVerificationModal"
        :isModalVisible="showConnectionVerificationModal" />

    </shell>
  </div>
</template>

<script>
 import {mapState, mapActions} from 'vuex';
 import api from '@/api';
 import Shell from '@/components/Shell'
 import SpellBar from '@/components/SpellBar';

 import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js';
 import AddConnectionModal from '@/components/AddConnectionModal'
 import ConnectionVerificationModal from '@/components/ConnectionVerificationModal'


 const HANDLE_PATTERN = /[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*/

 export default {
   components: {Shell, SpellBar, AddConnectionModal, ConnectionVerificationModal },

   data () {
     return {
       SERVER: process.env.VUE_APP_API_URL,
       isSharingEnabled: false,
       reactionGroupPref: false,
       connections: [],
       isAddConnectionModalVisible: false,
       showConnectionVerificationModal: false,
       verificationConnection: null
     }
   },

   created () {
     this.reactionGroupPref = this.member.pref_reaction_group === 'ENABLED' ? true : false;
     this.isSharingEnabled = this.member.prefs.is_sharing_enabled || false
     this.handle = this.member.handle || ''
     this.getConnections()
   },

   computed: {

     ...mapState({
       member: state => state.member,
       error: state => state.displayError
     }),

     jsURL () {
       return `javascript:u=location.href;void(open('${process.env.VUE_APP_WEB_URL}/capture?url=' + encodeURIComponent(u),'Tap','toolbar=no,width=500,height=800'))`;
     },
     jsURLNoUrl () {
       return `javascript:u=location.href;void(open('${process.env.VUE_APP_WEB_URL}/capture?url=' + encodeURIComponent(u),'Tap','toolbar=no,width=500,height=800'))`;
     }
   },

   methods: {
     ...mapActions(['updateMemberPrefReactionGroup', // TODO: combine with prefs
                    'updateMemberPrefs',
                    'updateMemberHandle']),

     async resendConnectionVerification (connection) {
       const {res, err} = await api.resetConnectionVerification(connection.id)

       if (err) {
         // TODO
         return;
       }

       this.verificationConnection = connection
       this.showConnectionVerificationModal = true
     },

     closeConnectionVerificationModal () {
       this.showConnectionVerificationModal = false
       this.getConnections()

     },


     async updateReactionGroupPref () {
       if (this.reactionGroupPref === true) {
         await this.updateMemberPrefReactionGroup({pref: 'ENABLED'})
       } else {
         await this.updateMemberPrefReactionGroup({pref: 'DISABLED'})
       }
     },

     formatIntlNumber (input) {
       const phoneNumber = parsePhoneNumberFromString(input)
       return phoneNumber.formatInternational()
     },

     async getConnections () {
       const {res, err} = await api.getConnections()
       this.connections = res
     },

     async deleteConnection (connection) {
       try {
         const typeMap = {
           SIGNAL: 'Signal connection',
           TELEGRAM: 'Telegram connection'
         }

         if (confirm(`Are you sure you want to delete this ${typeMap[connection.type]}?`)) {
           await api.deleteConnection(connection.id)
           await this.getConnections()
         }
       } catch (err) {
         // TODO
         // console.log(err)
       }

     },

     async updateEnablePublicNotes () {
       await this.updateMemberPrefs({is_sharing_enabled: this.isSharingEnabled})
     },

     async updateHandle () {
       await this.updateMemberHandle(this.handle)
     }
   }


 }
</script>
